module.exports = __webpack_public_path__ + "static/media/nut_jam.b5f138ef.png";